import { DialogService } from './dialog.service';
import { NavigateService } from './navigate.service';
import { NotificationService } from './notification.service';

export const SERVICES = [DialogService, NotificationService, NavigateService];
